<script lang="ts">
	import { RadioGroup as RadioGroupPrimitive } from "bits-ui";
	import { type RadioButtonVariants, getRadioButtonGroupCtx, radioButtonVariants } from "./index.js";
	import { cn } from "$lib/utils.js";
    import Label from "../label/label.svelte";

    type $$Props = RadioGroupPrimitive.ItemProps & RadioButtonVariants & {
		value: string;
	};
	type $$Events = RadioGroupPrimitive.ItemEvents;

	let className: string | undefined | null = undefined;

	export { className as class };
	export let variant: $$Props["variant"] = "default";
	export let selectVariant: $$Props["selectVariant"] = "default";
	export let size: $$Props["size"] = "default";
	export let grouped: $$Props["grouped"] = false
	export let value: $$Props["value"];

	const ctx = getRadioButtonGroupCtx();
</script>

<Label
    class={cn(
        radioButtonVariants({
            variant: ctx.variant || variant,
			selectVariant: ctx.selectVariant || selectVariant,
            size: ctx.size || size,
			grouped: ctx.grouped || grouped
        }),
        className
    )}
>
    <RadioGroupPrimitive.Item class="sr-only" {value} {...$$restProps} />
    <slot />
</Label>

